import {
  AddContextualData,
  BASE_JOURNEY_ENDPOINT,
  ContextualDataContext,
  DebugObservability,
  RealObservability,
  UTM_ADGID,
  UTM_CAMPAIGN,
  UTM_CAT,
  UTM_CONTENT,
  UTM_CTA,
  UTM_EXTERNALID,
  UTM_GEO,
  UTM_MEDIUM,
  UTM_NTWK,
  UTM_SOURCE,
  UTM_SUBSITE,
  UTM_TERM,
  addDatadogRUMGlobalContext,
  analytics,
  buildDefaultDatadogOptions,
  buildDefaultSentryOpts,
  emptyContextualData,
  emptyJourneyEventContextualData,
  getDeployEnv,
  globalObservability,
  initJourney,
  loadGoogleTagManager,
  loadSegment,
  mergeContextualData,
  readUtmCookie,
  testonly,
  useContextualData,
  useFakeObservability,
  useObservability
} from "./chunks/chunk-RPTIIMWF.mjs";

// src/observability-slim.ts
function initObservability({
  appName,
  env,
  version,
  eventTrackingCategory,
  sentry,
  datadog,
  debug,
  sendJourneyEventsInDev,
  journeyEndpoint,
  lazyLoadAnalytics,
  isBot
}) {
  if (globalObservability.isInitialized()) {
    throw new Error("initObservability was already called");
  }
  env = env || getDeployEnv();
  if (env === "development") {
    let journeyEventClient = void 0;
    if (sendJourneyEventsInDev) {
      const { eventClient } = initJourney(BASE_JOURNEY_ENDPOINT);
      journeyEventClient = eventClient;
    }
    globalObservability.setCurrentInstance(
      new DebugObservability(
        {
          log: debug,
          sendJourneyEventsInDev,
          journeyEventClient,
          env
        },
        eventTrackingCategory
      )
    );
  } else {
    if (typeof window !== "undefined" && !isBot) {
      loadGoogleTagManager(lazyLoadAnalytics);
      loadSegment(void 0, lazyLoadAnalytics);
    }
    const realObservabilityInstance = new RealObservability(
      eventTrackingCategory
    );
    if (!isBot) {
      const { eventClient, userClient } = initJourney(journeyEndpoint);
      userClient && realObservabilityInstance.setJourneyUserClient(userClient);
      eventClient && realObservabilityInstance.setJourneyEventClient(eventClient);
    }
    globalObservability.setCurrentInstance(realObservabilityInstance);
    sentry?.init({ ...buildDefaultSentryOpts({ appName, env, version }), ...sentry }).then((sentryClient) => {
      realObservabilityInstance.setSentryClient(sentryClient);
    }).catch((e) => {
      console.error("Error initializing Sentry", e);
    });
    datadog?.init({ ...buildDefaultDatadogOptions({ appName, env, version }), ...datadog }).then((datadogRumClient) => {
      realObservabilityInstance.setDatadogRumClient(datadogRumClient);
    }).catch((e) => {
      console.error("Error initializing Datadog", e);
    });
  }
}
export {
  AddContextualData,
  ContextualDataContext,
  DebugObservability,
  RealObservability,
  UTM_ADGID,
  UTM_CAMPAIGN,
  UTM_CAT,
  UTM_CONTENT,
  UTM_CTA,
  UTM_EXTERNALID,
  UTM_GEO,
  UTM_MEDIUM,
  UTM_NTWK,
  UTM_SOURCE,
  UTM_SUBSITE,
  UTM_TERM,
  addDatadogRUMGlobalContext,
  analytics,
  emptyContextualData,
  emptyJourneyEventContextualData,
  globalObservability,
  initObservability,
  mergeContextualData,
  readUtmCookie,
  testonly,
  useContextualData,
  useFakeObservability,
  useObservability
};
